const userActionTypes = {
  GET_LOGGED_IN_USER_DETAIL: "GET_LOGGED_IN_USER_DETAIL",
  GET_LOGGED_IN_USER_DETAIL_SUCCESS: "GET_LOGGED_IN_USER_DETAIL_SUCCESS",
  GET_LOGGED_IN_USER_DETAIL_FAIL: "GET_LOGGED_IN_USER_DETAIL_FAIL",
  USER_LOGOUT: "USER_LOGOUT",
  STORE_TOKEN_USER: "STORE_TOKEN_USER",
};
export default userActionTypes;
